<template lang="pug">
  #map-entity-list-dropdown
    BDropdown(aria-role="list" scrollable)
      button(
        id="fly-to-entity-button"
        class="button is-primary"
        slot="trigger"
      )
        span {{ flyToEntityTitle }}
        BIcon(icon="menu-down")
      template(v-for="entity in dropdownEntitiesNameInAlphabeticalNaturalSort")
        BDropdownItem(aria-role="listitem" @click="flyTo(entityName(entity))")
          article.media
            figure.media-left
              p.image.is-48x48
                img.is-rounded(
                  :src="_.get(entity, 'avatar', 'https://walkertracker.s3.amazonaws.com/avatars/anonymous.png')"
                  alt="avatar"
                  @error="entityAvatarOnError"
                )
            .media-content
              .content
                span.has-text-weight-semibold {{ entityName(entity) }}:&nbsp&nbsp
                span {{ _.get(entity, "steps", "_ _").toLocaleString()  }} steps

</template>

<script>
export default {
  name: "ChallengeMapEntityListDropdown",

  props: {
    leaderboard: {
      type: Array,
      required: true
    },

    isTeamChallenge: {
      type: Boolean,
      required: true
    },

    isPvsPChallenge: {
      type: Boolean,
      required: true
    }
  },

  computed: {
    dropdownEntitiesNameInAlphabeticalNaturalSort() {
      let name = this.entityNameAttribute;
      let sortedLeaderboard = [...this.leaderboard];

      return sortedLeaderboard.sort((a, b) => {
        return a[name].localeCompare(b[name], undefined, {
          numeric: true,
          sensitivity: "base"
        });
      });
    },

    flyToEntityTitle() {
      if (this.isPvsPChallenge) {
        return "Fly to Program";
      }
      if (this.isTeamChallenge) {
        return "Fly to Team";
      }
      return "Fly to Member";
    },

    entityNameAttribute() {
      if (this.isPvsPChallenge) {
        return "programName";
      }
      if (this.isTeamChallenge) {
        return "teamName";
      }
      return "username";
    }
  },

  methods: {
    entityName(entity) {
      if (this.isPvsPChallenge) {
        return entity.programName;
      }
      if (this.isTeamChallenge) {
        return entity.teamName;
      }
      return entity.username;
    },

    flyTo(entityName) {
      const marker = document.getElementById(`marker-${entityName}`);
      if (marker) {
        marker.click();
      } else {
        document.getElementById("marker-finish-line").click();
      }
    },

    entityAvatarOnError(event) {
      event.target.onerror = null;
      event.target.src =
        "https://walkertracker.s3.amazonaws.com/avatars/anonymous.png";
    }
  }
};
</script>

<style lang="sass" scoped>
#map-entity-list-dropdown
  position: absolute
  padding-left: .5rem
  padding-top: .5rem
  button
    box-shadow: 0px 3px 5px -1px #488889, 0px 6px 10px 0px #488889
</style>
